(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/product-base/assets/javascripts/marionette.js') >= 0) return;  svs.modules.push('/components/components/product-base/assets/javascripts/marionette.js');

var svs = svs || {};


svs.components.productBase = svs.components.productBase || {};

if (!window.Backbone) {
  return;
}

svs.components.productBase.Marionette = Marionette.View.extend({
  template: _.noop,

  initialize: function(options) {
    var self = this;

    this.productBase = options.productBase;

    this.productBase.on('tabChanged', function(index) {
      self.trigger('tabChanged', index);
    });

    _.bindAll(this, 'getMultiSwiper');
  },

  getMultiSwiper: function() {
    return this.productBase.multiSwiper;
  },

  onRender: function() {
    this.$el.html(this.productBase.el);
  },

  onAttach: function() {
    this.productBase.attachedToDOM();
  },

  onDestroy: function() {
    this.productBase.dispose();
  }
});


 })(window);